__turbopack_context__.v({
  "bodyContainer": "nK6xha_bodyContainer",
  "bodyImage": "nK6xha_bodyImage",
  "displayBackHairPart": "nK6xha_displayBackHairPart",
  "displayEyebrowsPart": "nK6xha_displayEyebrowsPart",
  "displayEyelinePart": "nK6xha_displayEyelinePart",
  "displayEyespart": "nK6xha_displayEyespart",
  "displayHairPart": "nK6xha_displayHairPart",
  "displayMouthPart": "nK6xha_displayMouthPart",
});
